import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  return <section id="pricing" className="py-20 px-4 bg-neutral-100 relative" data-id="element-189" data-mp="1naaltis4es29">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-190" data-mp="1s8lrrifaoif7">
        <div className="text-center mb-10" data-id="element-191" data-mp="1x8qazg7l7r94">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-neutral-900 uppercase" data-id="element-192" data-mp="1xa1hhnsf3d3x">
            Your Complete <span className="text-red-700" data-id="element-193" data-mp="2271mrwhg0btz">Fire Service Instructor Atlas</span> Package
          </h2>
          <p className="text-neutral-800/80 text-sm md:text-base" data-id="element-194" data-mp="2wjnpj1f5k0g">
            Everything You Need to Plan, Teach, Demonstrate, Review & Assess Firefighter Training
            More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-neutral-200 border-2 border-red-700 rounded-3xl p-1 relative shadow-xl shadow-neutral-900/10" data-id="element-195" data-mp="1mihjolsqflq8">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-400 text-neutral-950 font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-196" data-mp="25fsi646jib4m">
            <Sparkles size={14} data-id="element-197" data-mp="1vfrzmkghvz1h" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-198" data-mp="1rgj4pc9pxv4c">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-199" data-mp="k1xxl7eiis4r" />

            <p className="text-sm font-bold tracking-widest text-red-700 mb-3" data-id="element-200" data-mp="hhruf1xq35p9">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-neutral-50 border border-neutral-200 rounded-xl p-4" data-id="element-201" data-mp="hfx9hnmgbdl6">
              <li className="text-xs font-bold tracking-widest text-neutral-900" data-id="element-202" data-mp="7k3nzeqr89r9">
                THE COMPLETE 6-IN-1 TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-203" data-mp="3uweg8lx6t1ve" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-neutral-900" data-id="element-204" data-mp="3j1u7dflwpwo">
                      PLUS 5 PROFESSIONAL INSTRUCTOR BONUSES
                    </li>}
                  <li className="flex items-start gap-2 text-sm text-neutral-800" data-id="element-205" data-mp="3pymlzl92l3o1">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-206" data-mp="3bzwpo7u2r80q" /> : <Check size={16} className="text-red-700 shrink-0 mt-0.5" data-id="element-207" data-mp="3g186bnuz0iws" />}
                    <span data-id="element-208" data-mp="2xcxz0f31khn2">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-209" data-mp="36cb1gnsr05ya">
              <p className="text-sm text-neutral-800/60 mb-1" data-id="element-210" data-mp="36dcm9jzkg6t7">
                REGULAR VALUE: <span className="line-through" data-id="element-211" data-mp="31bn8vxovfh1y">$105 USD</span>
              </p>
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-212" data-mp="3g9fmulerrxe1">
                <span className="text-2xl md:text-3xl text-neutral-800/70" data-id="element-213" data-mp="3baw4euzdx3qf">TODAY:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-red-700" data-id="element-214" data-mp="3b91nrsv5bxs5">
                  $27 USD
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-215" data-mp="3l2saotbmk05q">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-neutral-800/60" data-id="element-216" data-mp="hym6uoeyd5ii">
              <span className="flex items-center gap-1.5" data-id="element-217" data-mp="lywa3tbd1hto">
                <Lock size={12} className="text-red-700" data-id="element-218" data-mp="lxbfk3p1pyvt" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-219" data-mp="qsh99ooowhug">
                <Zap size={12} className="text-red-700" data-id="element-220" data-mp="vofu52at7hq4" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-221" data-mp="3v5nx60ej04d9">
                <Wallet size={12} className="text-red-700" data-id="element-222" data-mp="30tsw0p20p6f" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}